var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { svgIcon } from '../svg-icon';
/**
 * @tdr
 */
export var DocumentAdd = svgIcon(function (props) { return (React.createElement("svg", __assign({}, props, { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }),
    React.createElement("path", { fill: "currentColor", d: "M15.8333 20H2.5V2.08331H10.8333V3.33331H3.75V18.75H14.5833V7.08331H15.8333V20Z" }),
    React.createElement("path", { fill: "currentColor", d: "M12.5 7.91663H5.83331V9.16663H12.5V7.91663Z" }),
    React.createElement("path", { fill: "currentColor", d: "M12.5 10.4166H5.83331V11.6666H12.5V10.4166Z" }),
    React.createElement("path", { fill: "currentColor", d: "M9.16665 12.9166H5.83331V14.1666H9.16665V12.9166Z" }),
    React.createElement("path", { fill: "currentColor", d: "M17.9167 2.08331H12.5V3.33331H17.9167V2.08331Z" }),
    React.createElement("path", { fill: "currentColor", d: "M15.8333 0H14.5833V5.41667H15.8333V0Z" }))); });
//# sourceMappingURL=DocumentAdd.js.map